import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from '@/pages/home/components/HeroSection';
import TrainingSection from '@/pages/home/components/TrainingSection';
import BenefitsSection from '@/pages/home/components/BenefitsSection';
import TestimonialsSection from '@/pages/home/components/TestimonialsSection';
import ContactSection from '@/pages/home/components/ContactSection';

const WA_LINK = "https://wa.me/243808631779?text=Bonjour%20je%20souhaite%20m'inscrire%20à%20une%20formation";

export default function HomePage() {
  return (
    <div className="min-h-screen font-sans">
      <Navbar />
      <main>
        <HeroSection />
        <TrainingSection />
        <BenefitsSection />
        <TestimonialsSection />
        <ContactSection />
      </main>
      <Footer />

      {/* Floating WhatsApp Button */}
      <a
        href={WA_LINK}
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-8 right-8 z-50 w-16 h-16 flex items-center justify-center bg-[#25D366] rounded-full shadow-2xl hover:scale-110 transition-transform duration-300 cursor-pointer"
        aria-label="Contacter via WhatsApp"
        style={{ animation: 'waPulse 2.5s ease-in-out infinite' }}
      >
        <i className="ri-whatsapp-line text-white text-3xl"></i>
      </a>

      <style>{`
        @keyframes waPulse {
          0%, 100% { box-shadow: 0 0 0 0 rgba(37, 211, 102, 0.5); }
          50% { box-shadow: 0 0 0 16px rgba(37, 211, 102, 0); }
        }
      `}</style>
    </div>
  );
}
